import { DateTime } from "luxon";

export const appVersion = {
  _version: null,

  installedVersion: null,
  updated: null,
  isNew: false,

  init() {
    this._getInstalledVersion();
    this._getAppVersion();
  },

  _getInstalledVersion() {
    this.installedVersion = localStorage.getItem("version");
    this.updated = localStorage.getItem("updated");
  },

  _setInstalledVersion() {
    localStorage.setItem("version", this._version);

    localStorage.setItem("updated", DateTime.now().toLocaleString(DateTime.DATETIME_FULL));
    this._getInstalledVersion();
  },

  _getAppVersion() {
    // Register listener first
    const onMessage = (event) => {
      if (event.data.type === "version") {
        this._version = event.data.value;
        if (this.installedVersion !== this._version) {
          this.isNew = true;
          this._setInstalledVersion();
        }
        console.log("Current SW version:", this._version);
        navigator.serviceWorker.removeEventListener("message", onMessage);
      }
    };

    navigator.serviceWorker.addEventListener("message", onMessage);

    // Ask SW for version
    navigator.serviceWorker.ready.then((reg) => {
      if (reg.active) {
        reg.active.postMessage({ type: "getVersion" });
      }
    });
  },
};
